/* eslint-disable prefer-destructuring */
/**

Coded by www.techhighway.ca

*/

// @mui material components
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";

export default styled(Select)(({ theme, ownerState }) => {
  const { palette, functions } = theme;
  const { disabled } = ownerState;
  const { grey, transparent } = palette;

  return {
    ".MuiSelect-select": {
      height: "auto !important",
      minHeight: "3.3em !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap !important",
      overflow: "hidden !important",
      backgroundColor: disabled ? `${grey[200]} !important` : transparent.main,
    },
  };
});
